<template>
  <li class="card-list-item">
    <span class="card-detail-title">{{label}}:</span>&nbsp;
    <span v-if="typeof val === 'string' || typeof val === 'number'">
      <router-link v-if="url" :to="url">{{val}}</router-link>
      <span v-else>{{val}}</span>
    </span>
    <span v-else-if="Array.isArray(val) && typeof val[0] === 'object'">
      <span
        v-for="(item, index) in val"
        :key="item.id"
      >
        <router-link v-if="url" :to="`${url}${item.id}`">{{capitalize(item[field])}}</router-link>
        <span v-else>{{item[field]}}</span>
        {{index !== val.length - 1 ? ', ': ''}}
      </span>
    </span>
    <span v-else-if="Array.isArray(val)">
      <span
        v-for="(item, index) in val"
        :key="item"
      >
        <router-link v-if="url" :to="`${url}${item}`">{{capitalize(item)}}</router-link>
        <span v-else>{{item}}</span>
        {{index !== val.length - 1 ? ', ': ''}}
      </span>
    </span>
  </li>
</template>

<script>
import { capitalize } from '../../utils/helpers';

export default {
  name: 'CardDetail',
  props: {
    label: {
      type: String,
      required: true
    },
    val: {
      type: [String, Array, Number],
      required: true
    },
    url: {
      type: String
    },
    field: {
      type: String
    }
  },
  methods: {
    capitalize
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';

.card-list-item {
  list-style: none;
  font-size: 14px;
  padding: 5px 0;
}

.card-detail-title {
  font-size: 14px;
  font-weight: 900;
  color: $accent-color;
  padding-bottom: 10px;
  margin-bottom: 5px;
}
</style>


